import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteProject = (token: string) => (projectId: number) =>
  deleteTemplateFn(token, uri.projectById(projectId));

/*

403
"Cannot delete an approved project."

*/
